module.exports = __webpack_public_path__ + "media/images/sp/site_navigation/icon_close-07de5b83ce045f2c5b674a2547f6dcf3.svg";